<div class="student-card p-3 p-md-4">

  <div class="d-flex align-items-center justify-content-between mb-3">
    <p class="fs-small fw-800 color-gray-950 mb-0">
      <i class="bi bi-graph-up-arrow color-brand-primary me-2"></i>
      {{'students.exam_history.title'|translate|uppercase}}
      <span class="fs-xsmall fw-500 color-gray-400 ms-1">· {{examName}}</span>
    </p>

    <div class="d-flex align-items-center" *ngIf="lastScore() !== null">
      <span class="fs-small fw-400 color-gray-400 me-2">
        {{'students.exam_history.last'|translate}}
        <span class="fw-800 color-gray-950">{{lastScore()}}</span>
        {{'students.exam_history.net'|translate}}
      </span>
      <span class="delta-pill fs-xsmall fw-800" *ngIf="delta() !== null" [class.negative]="delta() < 0">
        {{delta() > 0 ? '+' : ''}}{{delta()}}
      </span>
    </div>
  </div>

  <ngx-skeleton-loader
    *ngIf="isLoading" count="1" appearance="line"
    [theme]="{height: '190px', 'border-radius': '12px', margin: '0'}"/>

  <div class="chart-host" #chartHost *ngIf="!isLoading && scores().length > 1"></div>

  <div class="text-center py-4" *ngIf="!isLoading && scores().length < 2">
    <p class="fs-small fw-800 color-gray-950 mb-1">{{'students.exam_history.empty_title'|translate}}</p>
    <p class="fs-small fw-400 color-gray-400 mb-0">{{'students.exam_history.empty_desc'|translate}}</p>
  </div>

</div>
